import React from "react";
import {
  DirectionsRenderer,
  DirectionsService,
  GoogleMap,
  useJsApiLoader
} from "@react-google-maps/api";

import searchIcon from "./search.png"; // Import the search icon

const containerStyle = {
  width: "300px",
  height: "400px",
  borderRadius: "25px",
  border: "2px solid #73AD21",
  margin: "20px auto",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
};

const inputBoxStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "20px"
};

const inputStyle = {
  width: "80%",
  border: "none",
  borderBottom: "2px solid #73AD21",
  padding: "5px"
};

const iconStyle = {
  width: "20px",
  height: "20px",
  marginLeft: "10px"
};

const center = {
  lat: -3.745,
  lng: -38.523
};

const searchBoxStyle = {
  backgroundColor: "white",
  borderRadius: "15px", // Adjust the radius to control roundness
  padding: "10px",
  marginTop: "20px", // Adjust the margin to control the distance from the image
  display: "flex",
  alignItems: "center"
};

const SearchStyle = { border: "none", outline: "none", flex: 1 };

function MapsComponent() {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyDBppiMnmArk33LDCPVkAeA49U0qXUNKA0"
  });

  const [map, setMap] = React.useState(null);

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);

    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  return isLoaded ? (
    <div style={containerStyle}>
      {/* <div style={searchBoxStyle}>
        <input type="text" placeholder="From" style={SearchStyle} />
        <img src={searchIcon} alt="Search" style={iconStyle} />
      </div>
      <div style={searchBoxStyle}>
        <input type="text" placeholder="To" style={SearchStyle} />
        <img src={searchIcon} alt="Search" style={iconStyle} />
      </div> */}
      {/* <div style={inputBoxStyle}>
        <input type="text" style={inputStyle} placeholder="From" />
        <img src="current-location.svg" alt="Current Location" style={iconStyle} />
      </div>
      <div style={inputBoxStyle}>
        <input type="text" style={inputStyle} placeholder="To" />
        <img src="search_icon.png" alt="Search" style={iconStyle} />
      </div> */}
      <GoogleMap
        mapContainerStyle={{ width: "100%", height: "100%" }}
        center={center}
        zoom={10}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        {/* Child components, such as markers, info windows, etc. */}
        <></>
      </GoogleMap>
    </div>
  ) : (
    <></>
  );
}

export default React.memo(MapsComponent);
